(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('FileCategoryService', FileCategoryService)

    /** @ngInject */
    function FileCategoryService(HttpService) {
        const FileCategoryService = {
            getAll: getAll
        }

        return FileCategoryService;

        function getAll() {
            return HttpService.get(`/files/categories`);
        }
    }
}());